<template>
  <section class="campaign">
    <Header :user="user" />
    <main class="main  animated fadeIn faster" :class="{ 'expand-main' : isMenuCollapse }">
        <Fieldset :title="'Oliver\'s Calendars'" :open="true">
        <div class="row">
          <div  class="col-xl-2 col-lg-3 card m-2 p-2 ml-4"
           :class="calendar.link_id == undefined ? 'bg-danger text-white' : 'bg-light'"
            v-for="(calendar,key) in oliverCalendars">
             <div class="mb-2">
             <router-link :to="'/opportunities/' + calendar.link_id" target="_blank"
               >
                <div class="text-primary" >
                  {{calendar.link_id}}
                </div>
              </router-link>
              </div>

              <CalendlyEvent
              v-if="calendar.name !== undefined"
                    :eventCalendly="calendar"></CalendlyEvent>

              <div v-if="calendar.name == undefined" >
                {{calendar}}
              </div>
          </div>
        </div>
        </Fieldset>


        <div v-for="(calendar,key) in calendars">
          <Fieldset :title="calendar.name" :mykey="key" :open="false"
          @opennow="getEvents(calendar.calendly)" >
          <h6>{{calendar.users}}</h6>
            <small>{{calendar.calendly}}</small>
              <LoadingSpinner v-if="events[calendar.calendly] === undefined" />
            <div class="row" v-if="events[calendar.calendly] !== undefined">
              <div class="col-3 card m-2 p-2"
              :class="event.link_id == undefined ? 'bg-danger text-white' : 'bg-light'" v-for="event in events[calendar.calendly].collection">
                <div v-for="link in event.link_id">

                      <router-link :to="'/opportunities/' + link" target="_blank"
                       >
                        <div class="text-primary" >
                          {{ link }}
                        </div>
                      </router-link>
                </div>
               <CalendlyEvent :eventCalendly="event" />
              </div>
              <button v-if="!loadingnext && events[calendar.calendly].pagination !== undefined && events[calendar.calendly].pagination.next_page !== null" class="btn btn-sm btn-primary"
              @click="nextPage(calendar.calendly,events[calendar.calendly].pagination.next_page)">next</button>
               <LoadingSpinner v-if="loadingnext" />
            </div>
          </Fieldset>
        </div>
    </main>
  </section>
</template>
<script>
import { mapState, mapActions } from "vuex";
import Header from "@/components/Header.vue";
import ViewDashboard from "@/components/Dashboard/ViewDashboard.vue";
import DashboardAdmin from "@/components/Dashboard/DashboardAdmin.vue";
import ToastNotifications from "@/components/ToastNotifications.vue";
import Fieldset from "@/components/Common/Fieldset.vue";
import CalendlyEvent from "@/components/Common/CalendlyEvent.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { calendlyService,clientsService } from "@/_services";


export default {

  data(){
    return{
        calendars:[],
        oliverCalendars:[],
        events:[],
        loading:false,
        loadingnext:false
    }
  },

  created() {
     this.loading=true
      calendlyService.getCalendars().then(
      (result) => {
        this.calendars = result
        this.loading=false
      })

      clientsService.getAllCalendarNylas().then(
      (result) => {
        this.oliverCalendars = result
      })
  },

  components: {
    ToastNotifications,
    ViewDashboard,
    Fieldset,
    DashboardAdmin,
    CalendlyEvent,
    LoadingSpinner
  },

  computed: {
    ...mapState({
      headerTab: state => state.header.tab,
      isMenuCollapse: state => state.sidebar.isNavOpen,
      paymentMethods: state => state.billings.all
    }),

    user() {
      return this.$store.state.authentication.user;
    },
  },
  methods: {
    getEvents(token){
      calendlyService.getAllEvents(token,10).then((res) => {
        this.events[token] = res
        this.$forceUpdate()
      })
    },
    nextPage(token,url){
      this.loadingnext = true
      calendlyService.nextPage(url,token).then((res) => {
        res.collection.forEach((item, key) => {
          this.events[token].collection.push(item)
        })
        this.events[token].pagination = res.pagination
        this.$forceUpdate()
        this.loadingnext = false
      })
    }
  }
};
</script>
